import { format, startOfMonth } from "date-fns";

interface GetStartOfMonthArgs {
  date?: Date;
}

/**
 * Returns the first day of the month for a given date, formatted as "yyyy-MM-dd".
 * Defaults to the current date if no date is provided.
 *
 * @example
 * getStartOfMonth() // "2026-04-01" (if today is 2026-04-10)
 * getStartOfMonth({ date: new Date("2026-03-15") }) // "2026-03-01"
 */
export function getStartOfMonth({ date = new Date() }: GetStartOfMonthArgs = {}): string {
  return format(startOfMonth(date), "yyyy-MM-dd");
}
